import { DecisionFormFieldsNamesTemplatesEnum } from '../enums/DecisionFormFieldsNamesTemplatesEnum';

export const decisionErrorFieldsArrangeArray: Array<DecisionFormFieldsNamesTemplatesEnum> = [
  DecisionFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION,
  DecisionFormFieldsNamesTemplatesEnum.JUDGMENTS,
  DecisionFormFieldsNamesTemplatesEnum.JUDGMENT,
  DecisionFormFieldsNamesTemplatesEnum.ORGANIZATION_LOCATION_ADDRESS,
];
